// Database
// 

JLM.database = (function() {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Constants: Private _______________________________________________________
	
	// Development mode (no session storage)
	const DEVELOPER_MODE = false;
	
	// Browser storage IDs
	const ID_TALENTLIST = 'jl_tl_', // (eg. "jlm_tl_actors")
		  ID_SHORTLIST = 'jl_sl',
		  ID_ATTR_COUNTRIES = 'jl_countries',
		  ID_ATTR_LOCATIONS = 'jl_locations',
		  ID_ATTR_ETHNICITIES = 'jl_ethnicities',
		  ID_ATTR_VOICE_SKILLS = 'jl_voice_skills',
		  ID_ATTR_VOICE_ACCENTS = 'jl_voice_accents',
		  ID_ATTR_VOICE_LANGUAGES = 'jl_voice_languages',
		  ID_ATTR_SOCIAL_CATEGORIES = 'jl_social_categories',
		  ID_ATTR_TALENT_SKILLS = 'jl_tl_skills',
		  ID_ATTR_TALENT_INTERESTS = 'jl_tl_interests',
		  ID_ATTR_TALENT_TOPICS = 'jl_tl_topics',
		  ID_ATTR_TALENT_SPEAKER_TYPES = 'jl_tl_speaker_types',
		  ID_ATTR_TALENT_CATEGORIES = 'jl_tl_categories';
	
	
	
	// Variables: Private _______________________________________________________
	
	// Browser support
	let support_localstorage = isLocalStorageSupported(),
		support_sessionstorage = isSessionStorageSupported();
	
	// Data
	let data_talent_all = null,		// All talent
		data_talent_search = null,	// Searchable talent
		data_talent_list = {};		// Searchable talent by division
	
	// Shortlist
	let data_shortlist = null;
	
	// Attributes
	let data_countries = null,
		data_locations = null,
		data_ethnicities = null,
		data_voice_skills = null,
		data_voice_accents = null,
		data_voice_languages = null,
		data_social_categories = null,
		data_talent_skills = null,
		data_talent_interests = null,
		data_talent_topics = null,
		data_talent_speaker_types = null,
		data_talent_categories = null;
	
	
	
	// Methods: Private _________________________________________________________
	
	// Browser support for localstorage
	// 
	function isLocalStorageSupported() {
		try {
			var test = 'jlm_localstorage';
			localStorage.setItem(test, test);
			localStorage.removeItem(test);
			return true;
		} catch(e) {
			return false;
		}
	}
	function isSessionStorageSupported() {
		try {
			var test = 'jlm_sessionstorage';
			sessionStorage.setItem(test, test);
			sessionStorage.removeItem(test);
			return true;
		} catch(e) {
			return false;
		}
	}
	
	
	
	// Methods: Talent Data _____________________________________________________
	
	// Load full list of talent for indexing
	// 
	INSTANCE.loadTalentList = function( type, callback ) {
		if (type === 'all') {
			// Already loaded
			if ( data_talent_all ) {
				callback( data_talent_all );
				return;
			}
			
			// Session storage
			const id_storage_all = ID_TALENTLIST + 'all';
			if ( support_sessionstorage && !DEVELOPER_MODE ) {
				const str_storage_all = sessionStorage.getItem( id_storage_all );
				if ( str_storage_all ) {
					data_talent_all = JSON.parse( str_storage_all );
					callback( data_talent_all );
					return;
				}
			}
			
			// Load from API
			$.get('/api/search/' + type, function( response ) {
				if ( response.length ) {
					data_talent_all = response;
					if ( support_sessionstorage ) {
						sessionStorage.setItem(id_storage_all, JSON.stringify( data_talent_all ));
					}
				}
				callback( response );
			});
		}
		else if (type === 'search') {
			// Already loaded
			if ( data_talent_search ) {
				callback( data_talent_search );
				return;
			}
			
			// Session storage
			const id_storage_search = ID_TALENTLIST + 'search';
			if ( support_sessionstorage && !DEVELOPER_MODE ) {
				const str_storage_search = sessionStorage.getItem( id_storage_search );
				if ( str_storage_search ) {
					data_talent_search = JSON.parse( str_storage_search );
					callback( data_talent_search );
					return;
				}
			}
			
			// Load from API
			$.get('/api/search/' + type, function( response ) {
				if ( response.length ) {
					data_talent_search = response;
					if ( support_sessionstorage ) {
						sessionStorage.setItem(id_storage_search, JSON.stringify( data_talent_search ));
					}
				}
				callback( response );
			});
		}
	};
	
	
	// Get list of talent by division
	// 
	INSTANCE.getTalentList = function( division_type ) {
		// Already loaded
		if ( data_talent_list[ division_type ] ) {
			return data_talent_list[ division_type ];
		}
		
		// Session storage
		const id_storage = ID_TALENTLIST + division_type;
		if ( support_sessionstorage && !DEVELOPER_MODE ) {
			const str_storage = sessionStorage.getItem( id_storage );
			if ( str_storage ) {
				data_talent_list[ division_type ] = JSON.parse( str_storage );
				return data_talent_list[ division_type ];
			}
		}
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage(id_storage);
		if ( data_page ) {
			data_talent_list[ division_type ] = data_page;
			if ( support_sessionstorage ) {
				sessionStorage.setItem(id_storage, JSON.stringify( data_page ));
			}
			return data_talent_list[ division_type ];
		}
	};
	
	
	// Get talent profile info
	// 
	INSTANCE.getTalentInfo = function( type, talent_id, callback ) {
		INSTANCE.loadTalentList(type, function( list ) {
			var i = list.length; while( i-- ) {
				if ( list[i][0] == talent_id ) {
					callback( list[i] );
					return;
				}
			}
			callback( null );
		});
	};
	
	
	// Get full talent profile (for a division)
	// 
	INSTANCE.getTalentDivisionProfile = function( talent_id, division_type, callback ) {
		$.get('/api/talent/' + talent_id + '/' + division, function( response ) {
			// ..
		});
	};
	
	
	// Get data from page meta tag
	// 
	INSTANCE.getDataFromPage = function( tag_id ) {
		let meta_tag = $('#' + tag_id),
			meta_content = meta_tag.attr('content');
		
		if ( meta_tag.length && meta_content !== '' ) {
			try {
				let json_data = JSON.parse( meta_content );
				meta_tag.remove();
				return json_data;
			} catch(e) {
				// if ( window.console && console.log ) console.log('JSON load error [' + tag_id + ']');
				return false;
			}
		} else {
			return false;
		}
	};
	
	
	
	// Methods: Shortlist Data __________________________________________________
	
	// Get list
	// eg. { actors: [1001,1002,1003], voices: [1004], social: [1005,1006] }
	// 
	INSTANCE.getShortlist = function() {
		if ( !data_shortlist ) {
			data_shortlist = {};
			if ( support_localstorage ) {
				let str_shortlist = localStorage.getItem( ID_SHORTLIST );
				if ( str_shortlist ) {
					let storage_shortlist = JSON.parse( str_shortlist );
					if ( !$.isArray( storage_shortlist ) ) {
						data_shortlist = storage_shortlist;
					}
				}
			}
		}
		return data_shortlist;
	};
	
	
	// Save updates
	// 
	INSTANCE.setShortlist = function( shortlist ) {
		if ( support_localstorage ) {
			localStorage.setItem(ID_SHORTLIST, JSON.stringify( shortlist ));
		}
		data_shortlist = shortlist;
	};
	
	
	// Check if ID is in shortlist
	// 
	INSTANCE.isInShortlist = function( talent_id, division_type ) {
		let shortlist = INSTANCE.getShortlist();
		return ( shortlist[ division_type ] && shortlist[ division_type ].indexOf( talent_id ) >= 0 );
	};
	
	
	
	// Methods: Attribute Data __________________________________________________
	
	// Get list of countries
	// 
	INSTANCE.getCountries = function() {
		// Already loaded
		if ( data_countries ) return data_countries;
		
		// Session storage
		if ( support_sessionstorage && !DEVELOPER_MODE ) {
			const str_storage = sessionStorage.getItem( ID_ATTR_COUNTRIES );
			if ( str_storage ) {
				data_countries = JSON.parse( str_storage );
				return data_countries;
			}
		}
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_COUNTRIES );
		if ( data_page ) {
			data_countries = data_page;
			if ( support_sessionstorage ) {
				sessionStorage.setItem( ID_ATTR_COUNTRIES, JSON.stringify( data_page ) );
			}
			return data_countries;
		}
	};
	
	
	// Get list of locations (cities)
	// 
	INSTANCE.getLocations = function() {
		// Already loaded
		if ( data_locations ) return data_locations;
		
		// Session storage
		// if ( support_sessionstorage && !DEVELOPER_MODE ) {
		//	const str_storage = sessionStorage.getItem( ID_ATTR_LOCATIONS );
		//	if ( str_storage ) {
		//		data_locations = JSON.parse( str_storage );
		//		return data_locations;
		//	}
		// }
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_LOCATIONS );
		if ( data_page ) {
			data_locations = data_page;
			// if ( support_sessionstorage ) {
			//	sessionStorage.setItem( ID_ATTR_LOCATIONS, JSON.stringify( data_page ) );
			// }
			return data_locations;
		}
	};
	
	
	// Get list of ethnicities for filtering
	// 
	INSTANCE.getEthnicities = function() {
		// Already loaded
		if ( data_ethnicities ) return data_ethnicities;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_ETHNICITIES );
		if ( data_page ) {
			data_ethnicities = data_page;
			return data_ethnicities;
		}
	};
	
	
	// Get list of voice skills for filtering
	// 
	INSTANCE.getVoiceSkills = function() {
		// Already loaded
		if ( data_voice_skills ) return data_voice_skills;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_VOICE_SKILLS );
		if ( data_page ) {
			data_voice_skills = data_page;
			return data_voice_skills;
		}
	};
	
	
	// Get list of voice skills for filtering
	// 
	INSTANCE.getVoiceAccents = function() {
		// Already loaded
		if ( data_voice_accents ) return data_voice_accents;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_VOICE_ACCENTS );
		if ( data_page ) {
			data_voice_accents = data_page;
			return data_voice_accents;
		}
	};
	
	
	// Get list of voice languages for filtering
	// 
	INSTANCE.getVoiceLanguages = function() {
		// Already loaded
		if ( data_voice_languages ) return data_voice_languages;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_VOICE_LANGUAGES );
		if ( data_page ) {
			data_voice_languages = data_page;
			return data_voice_languages;
		}
	};
	
	
	// Get list of content creator and brand ambassador categories for filtering
	// 
	INSTANCE.getSocialCategories = function() {
		// Already loaded
		if ( data_social_categories ) return data_social_categories;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_SOCIAL_CATEGORIES );
		if ( data_page ) {
			data_social_categories = data_page;
			return data_social_categories;
		}
	};
	
	
	// Get list of talent skills for filtering
	// 
	INSTANCE.getTalentSkills = function() {
		// Already loaded
		if ( data_talent_skills ) return data_talent_skills;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_TALENT_SKILLS );
		if ( data_page ) {
			data_talent_skills = data_page;
			return data_talent_skills;
		}
	};
	
	
	// Get list of talent interests for filtering
	// 
	INSTANCE.getTalentInterests = function() {
		// Already loaded
		if ( data_talent_interests ) return data_talent_interests;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_TALENT_INTERESTS );
		if ( data_page ) {
			data_talent_interests = data_page;
			return data_talent_interests;
		}
	};
	
	
	// Get list of talent topics for filtering
	// 
	INSTANCE.getTalentTopics = function() {
		// Already loaded
		if ( data_talent_topics ) return data_talent_topics;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_TALENT_TOPICS );
		if ( data_page ) {
			data_talent_topics = data_page;
			return data_talent_topics;
		}
	};
	
	
	// Get list of talent speaker topics for filtering
	// 
	INSTANCE.getTalentSpeakerTypes = function() {
		// Already loaded
		if ( data_talent_speaker_types ) return data_talent_speaker_types;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_TALENT_SPEAKER_TYPES );
		if ( data_page ) {
			data_talent_speaker_types = data_page;
			return data_talent_speaker_types;
		}
	};
	
	
	// Get list of talent categories for filtering
	// 
	INSTANCE.getTalentCategories = function() {
		// Already loaded
		if ( data_talent_categories ) return data_talent_categories;
		
		// Embedded on page
		const data_page = INSTANCE.getDataFromPage( ID_ATTR_TALENT_CATEGORIES );
		if ( data_page ) {
			data_talent_categories = data_page;
			return data_talent_categories;
		}
	};
	
	
	
	// Response _________________________________________________________________
	
	return INSTANCE;
	
})();